import { FC } from 'react';
import { ListCheckNavButton, ListCheckStackCount } from '../../styles';
import { listCheckCopy } from './listCheckCopy';

interface StackNavProps {
  count: number;
  index: number;
  onChange: (index: number) => void;
}

const StackNav: FC<StackNavProps> = ({ count, index, onChange }) =>
  count > 1 ? (
    <>
      <ListCheckNavButton
        type="button"
        id="list-check-previous"
        data-testid="list-check-previous"
        disabled={index === 0}
        onClick={() => onChange(index - 1)}
      >
        <img src="/assets/images/icon-arrow-left.svg" alt="" />
        {listCheckCopy.previous}
      </ListCheckNavButton>
      <ListCheckStackCount data-testid="list-check-stack-count">
        {`${index + 1} of ${count}`}
      </ListCheckStackCount>
      <ListCheckNavButton
        type="button"
        id="list-check-next"
        data-testid="list-check-next"
        disabled={index === count - 1}
        onClick={() => onChange(index + 1)}
      >
        {listCheckCopy.next}
        <img src="/assets/images/icon-arrow-right.svg" alt="" />
      </ListCheckNavButton>
    </>
  ) : null;

export default StackNav;
